import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <section className="container-page section">
      <div className="mx-auto max-w-xl py-10 text-center">
        <p className="eyebrow">404</p>

        <h1 className="page-title mt-4">{t("notFound.title")}</h1>
        <p className="page-sub mx-auto">{t("notFound.subtitle")}</p>

        <div className="mt-9 flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-primary">
            {t("notFound.home")}
          </Link>
          <Link to="/urunler" className="btn-secondary">
            {t("products")}
          </Link>
          <Link to="/iletisim" className="btn-secondary">
            {t("contactNavbar")}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
